import { render } from "./PartnerList.vue?vue&type=template&id=1903a843"
import script from "./PartnerList.vue?vue&type=script&lang=js"
export * from "./PartnerList.vue?vue&type=script&lang=js"

import "./PartnerList.vue?vue&type=style&index=0&id=1903a843&lang=scss"
script.render = render

export default script